import { ValueSeparator } from '../separators';

export enum SelectFilterOperationType {
  Is = 'Is',
  IsNot = 'IsNot',
  IsOneOf = 'IsOneOf',
  IsNoneOf = 'IsNoneOf',
  IsEmpty = 'IsEmpty',
  IsNotEmpty = 'IsNotEmpty',
  // IsAtLeast & IsAtMost are used for single choice fields ONLY
  IsAtLeast = 'IsAtLeast',
  IsAtMost = 'IsAtMost',
}

export const SelectFilterOperationTypes = [
  SelectFilterOperationType.Is,
  SelectFilterOperationType.IsNot,
  SelectFilterOperationType.IsOneOf,
  SelectFilterOperationType.IsNoneOf,
  SelectFilterOperationType.IsEmpty,
  SelectFilterOperationType.IsNotEmpty,
];

export const SelectFilterOperationTypesForLevelField = [
  SelectFilterOperationType.Is,
  SelectFilterOperationType.IsNot,
  SelectFilterOperationType.IsAtLeast,
  SelectFilterOperationType.IsAtMost,
  SelectFilterOperationType.IsEmpty,
  SelectFilterOperationType.IsNotEmpty,
];

export const SelectFilterOperationTypesForSprintField = [
  SelectFilterOperationType.IsEmpty,
  SelectFilterOperationType.IsNotEmpty,
];

export const isOptional = (type: SelectFilterOperationType) =>
  type === SelectFilterOperationType.IsEmpty ||
  type === SelectFilterOperationType.IsNotEmpty;

export const isOptionalForTaskBlockingStatus = (
  type: SelectFilterOperationType,
) =>
  type === SelectFilterOperationType.Is ||
  type === SelectFilterOperationType.IsNot ||
  type === SelectFilterOperationType.IsEmpty ||
  type === SelectFilterOperationType.IsNotEmpty;

export const valueToString =
  <T>(mapper: (x: T) => string) =>
  (value: T[]): string => {
    return value.map((x) => mapper(x)).join(ValueSeparator);
  };

export const valueFromString =
  <T>(mapper: (x: string) => T, valueSeparator: string = ValueSeparator) =>
  (value: string): T[] => {
    return (value ?? '')
      .split(valueSeparator)
      .filter((x) => x !== '')
      .map((x) => mapper(x));
  };
